module.exports = __webpack_public_path__ + "static/media/sonja.4cd4cd45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/sonja.png
// module id = 1492
// module chunks = 0